module.exports = __webpack_public_path__ + "static/media/planexp.1c07365a.png";